import { render, staticRenderFns } from "./FeedbackSignDetail.vue?vue&type=template&id=55e2fd3c&scoped=true"
import script from "./FeedbackSignDetail.vue?vue&type=script&lang=ts"
export * from "./FeedbackSignDetail.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackSignDetail.vue?vue&type=style&index=0&id=55e2fd3c&prod&lang=scss"
import style1 from "./FeedbackSignDetail.vue?vue&type=style&index=1&id=55e2fd3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e2fd3c",
  null
  
)

export default component.exports